export default __webpack_public_path__ + "static/media/avatar_small.7f169f57.svg";